import api from './axios';

export const listApiKeys = () => api.get('/api-keys').then((r) => r.data);
export const createApiKey = (data) => api.post('/api-keys', data).then((r) => r.data);
export const revokeApiKey = (id) => api.post(`/api-keys/${id}/revoke`).then((r) => r.data);
